export const SET_LINKEDIN_INDUSTRIES = 'SET_LINKEDIN_INDUSTRIES';

export function setLinkedinIndustries(payload) {
  return { type: SET_LINKEDIN_INDUSTRIES, payload };
}
